
import { Result } from 'antd';
import './Unauthorized.less';

export const Unauthorized = () => {
    return (
        <div className="app-page "><Result status="403" title="403" subTitle="Sorry, you are not authorized to access this page." /></div>
    );
};
